"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlaySoundAction = void 0;
var tslib_1 = require("tslib");
var interfaces_1 = require("@dp-instant/interfaces");
var core_1 = require("@dp-instant/core");
var inversify_1 = require("inversify");
var AudioModel_1 = require("../model/AudioModel");
var PlaySoundAction = (function (_super) {
    tslib_1.__extends(PlaySoundAction, _super);
    function PlaySoundAction() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PlaySoundAction.prototype.execute = function (id) {
        var _a;
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var soundName;
            return tslib_1.__generator(this, function (_b) {
                if (!this.model.soundsMuted()) {
                    soundName = this.transformSound(id);
                    if (soundName) {
                        return [2, ((_a = (0, core_1.lazyGet)("howl_sounds")) === null || _a === void 0 ? void 0 : _a.play(soundName)) || -1];
                    }
                }
                return [2, -1];
            });
        });
    };
    PlaySoundAction.prototype.transformSound = function (type) {
        return type;
    };
    tslib_1.__decorate([
        (0, inversify_1.inject)(interfaces_1.TypesAudio.model),
        tslib_1.__metadata("design:type", AudioModel_1.AudioModel)
    ], PlaySoundAction.prototype, "model", void 0);
    PlaySoundAction = tslib_1.__decorate([
        (0, inversify_1.injectable)()
    ], PlaySoundAction);
    return PlaySoundAction;
}(core_1.Action));
exports.PlaySoundAction = PlaySoundAction;
//# sourceMappingURL=PlaySoundAction.js.map